import React, { FC } from "react";
import { PurchaseInfo } from "./PurchaseInfo/PurchaseInfo";
import { Divider } from "antd";
import { formattedDate } from "../../../../../utils/utilities/FormattedDate";
import { PraiceSpace } from "../../../../../utils/utilities/PraiceSpace";
import { getPurchaseType } from "../../../../../utils/utilities/GetPurchaseType";
import { ApplicationBank } from "../../../../../store/types/applicationBank.type";

export interface PurchaseInfo {
  name: string;
  value: string;
  type: {
    link: string;
    color: string;
  };
  href?: string;
}

/**
 * Типизация для объекта, который мы передаём в prop info компоненту <PurchaseInfo>
 * Ключи — названия разделов:
 * «Закупка»,
 * «Клиент»,
 * «Заказчик»,
 * «Начало и окончание БГ»
 */
export type PurchaseInfoListWithComponentRow<T> = {
  purchase: T[];
  client: T[];
  customer: T[];
  start_end_bg: T[];
};

/**
 * Раздел «Информация по закупке»
 * @param data - данные дополнительной заявки
 */
export const PurchaseInfoList: FC<{ data: ApplicationBank }> = ({ data }) => {
  const {
    purchase_lot,
    purchase,
    start_bg_at,
    finish_bg_at,
    bg_type,
    organization,
    link,
    application_sum_bg,
  } = data.application;

  const numberLot = purchase_lot?.number_lot ? purchase_lot?.number_lot : "-";
  const isStartBg = start_bg_at !== null ? formattedDate(start_bg_at) : "-";
  const isFinishBg = finish_bg_at !== null ? formattedDate(finish_bg_at) : "-";
  const purchaseTotalAt = purchase?.purchase_total_at
    ? purchase?.purchase_total_at
    : "-";
  const purchaseEndAt = purchase?.purchase_end_at
    ? purchase?.purchase_end_at
    : "-";

  const purchaseInfoList: PurchaseInfoListWithComponentRow<PurchaseInfo> = {
    purchase: [
      {
        name: "Тип банковской гарантии",
        value: bg_type?.name,
        type: { link: "div", color: "black" },
      },
      {
        name: getPurchaseType(purchase),
        value: purchase?.purchase_number,
        type: { link: "link", color: "blue" },
        href: link,
      },
      {
        name: "Сумма",
        value: PraiceSpace(application_sum_bg),
        type: { link: "div", color: "black" },
      },
      {
        name: "Предмет контракта",
        value: purchase?.subject_contract,
        type: { link: "div", color: "black" },
      },
      {
        name: "Номер лота",
        value: `${numberLot}`,
        type: { link: "div", color: "black" },
      },
      {
        name: "Дата проведения аукциона",
        value: formattedDate(purchaseTotalAt),
        type: { link: "div", color: "black" },
      },
      {
        name: "Окончание подачи заявок",
        value: formattedDate(purchaseEndAt),
        type: { link: "div", color: "black" },
      },
    ],
    client: [
      {
        name: "Наименование организации",
        value: organization?.name,
        type: { link: "div", color: "black" },
      },
      {
        name: "ИНН",
        value: `${organization?.inn}`,
        type: { link: "div", color: "black" },
      },
    ],
    customer: [
      {
        name: "Наименование организации",
        value: `${purchase_lot?.name_customer}`,
        type: { link: "div", color: "black" },
      },
      {
        name: "ИНН",
        value: `${purchase_lot?.inn_customer}`,
        type: { link: "div", color: "black" },
      },
    ],
    start_end_bg: [
      {
        name: "Дата начала",
        value: isStartBg,
        type: { link: "div", color: "black" },
      },
      {
        name: "Дата окончания",
        value: isFinishBg,
        type: { link: "div", color: "black" },
      },
    ],
  };

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        Информация по закупке
      </Divider>
      <PurchaseInfo info={purchaseInfoList} />
    </>
  );
};
